import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  standalone: false
})
export class TabComponent {
  @Output()
  public create = new EventEmitter<void>();

  @Output()
  public opened = new EventEmitter<void>();

  @Output()
  public loadData = new EventEmitter<void>();

  @Input()
  public creatable = false;

  @Input()
  public refreshable = false;
}
